/**
 * @generated SignedSource<<260149387c94718f75804cf8fa14d605>>
 * @relayHash d8ca14dbf366da01af9c4a17efa20cb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5f7bb8c4f38e1c4320d29deb2970e838e66e4598044b327c232fb82c9c32014d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentQuery } from './PopupContentQuery.graphql';

const node: PreloadableConcreteRequest<PopupContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5f7bb8c4f38e1c4320d29deb2970e838e66e4598044b327c232fb82c9c32014d",
    "metadata": {},
    "name": "PopupContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
